import { render, staticRenderFns } from "./StatusHistoryView.vue?vue&type=template&id=a90d4b26"
import script from "./StatusHistoryView.vue?vue&type=script&lang=js"
export * from "./StatusHistoryView.vue?vue&type=script&lang=js"
import style0 from "./StatusHistoryView.vue?vue&type=style&index=0&id=a90d4b26&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports